/**
 * Generic glass card for a single labeled value (e.g. seat number).
 * Callers only render an InfoCard when the underlying field is present —
 * this component never invents a fallback like "N/A".
 *
 * `delay` (an integer step) staggers the slide-up entrance animation via a
 * CSS custom property, see .info-card in ceremony-components.css.
 */
export default function InfoCard({ label, value, delay = 0 }) {
  return (
    <div className="info-card" style={{ '--delay': `${delay * 90}ms` }}>
      <span className="info-card__label">{label}</span>
      <span className="info-card__value" dir="auto">
        {value}
      </span>
    </div>
  );
}
